































import { Component, Vue } from 'vue-property-decorator';
import { $router } from '@/main';
import { Lang } from '@/lang/en/dashboard.ts';
import MainLayout from '@/layouts/Main.vue';
import DashboardCards from '@/utils/dashboardCards';

@Component({
  components: {
    MainLayout,
  },
})
export default class Dashboard extends Vue {
  private lang: object = Lang;
  private cards: object = DashboardCards;

  private navigateTo = (path) => {
    $router.push({
      name: path,
    });
  }

}
